import React, { ChangeEvent, FocusEvent, MouseEvent, forwardRef } from 'react'

import { InputProps } from '../../../types'

import { InputContainer } from './styles'

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type,
      min,
      max,
      name,
      id,
      placeholder,
      value,
      defaultValue,
      inputClass,
      onChange,
      onBlur,
      onFocus,
      onClick,
      onKeyDown,
      readOnly,
      disabled,
      width,
      height,
      defaultChecked,
      checked,
    },
    ref,
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange?.(e)
    }

    const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
      onBlur?.(e)
    }

    const handleClick = (e: MouseEvent<HTMLInputElement>) => {
      onClick?.(e)
    }

    const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
      onFocus?.(e)
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      onKeyDown?.(e)
    }

    return (
      <InputContainer
        type={type}
        min={min}
        max={max}
        name={name}
        id={id}
        ref={ref}
        placeholder={placeholder}
        value={value}
        className={inputClass}
        onChange={handleChange}
        onBlur={handleBlur}
        step="any"
        defaultValue={defaultValue}
        onFocus={handleFocus}
        readOnly={readOnly}
        onClick={handleClick}
        disabled={disabled}
        $height={height}
        $width={width}
        defaultChecked={defaultChecked}
        checked={checked}
        onKeyDown={handleKeyDown}
      />
    )
  },
)

export default Input
